import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export function Signout() {
  console.log("Was das feck?")
  localStorage.removeItem("authToken");
  let navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  });


  return <div>Signout successful</div>;
}
